export default {
  ethereum: '0x1d439Cfc5c11782b58bf030C552D298B2fCB33d6',
  avalanche: '0xe953ddd0f342356c8fd15618c6d1fbdf4ef2f9de',
  fantom: '0xd5C6BfDcc64edAd1612534a72B85c624CaA1Df33',
  polygon: '0x1d439Cfc5c11782b58bf030C552D298B2fCB33d6',
  bsc: '0x2c76dF0fcEBd5cFD67bf8b93Ff8cc3DfbFA855A3'
};
